module.exports = __webpack_public_path__ + "img/presentation.829417c2.svg";